export default __webpack_public_path__ + "static/media/bell-con.d5ab63db.svg";